//============================================================

// -- map

//============================================================

var map = {
  init: function () {
    // console.log('map init');

    var koshigaya = {
        lat: "35.895111",
        lng: "139.798165",
      },
      // soka = {
      //     lat : '35.835770',
      //     lng : '139.819343'
      // },
      // honkawagoe = {
      //     lat : '35.914968',
      //     lng : '139.481746'
      // },
      // meisei = {
      //     lat : '35.204309',
      //     lng : '136.892830'
      // },
      // arimatsu = {
      //     lat : '35.068182',
      //     lng : '136.971982'
      // },
      inazawa = {
        lat: "35.252668",
        lng: "136.772181",
      },
      // suzuka = {
      //     lat : '34.837354',
      //     lng : '136.590784'
      // },
      tsu = {
        lat: "34.675977",
        lng: "136.515867",
      },
      ise = {
        lat: "34.506601",
        lng: "136.722287",
      },
      ogaki = {
        lat: "35.365313",
        lng: "136.629498",
      };
    var latlng, map;

    for (var i = 0; i < 11; i++) {
      switch (i) {
        case 0:
          latlng = new google.maps.LatLng(koshigaya.lat, koshigaya.lng);
          break;
        // case 1:
        //     latlng = new google.maps.LatLng(soka.lat, soka.lng);
        //     break;
        // case 2:
        //     latlng = new google.maps.LatLng(honkawagoe.lat, honkawagoe.lng);
        //     break;
        // case 3:
        //     latlng = new google.maps.LatLng(meisei.lat, meisei.lng);
        //     break;
        // case 4:
        //     latlng = new google.maps.LatLng(arimatsu.lat, arimatsu.lng);
        //     break;
        // case 5:
        //     latlng = new google.maps.LatLng(inazawa.lat, inazawa.lng);
        //     break;
        // case 6:
        //     latlng = new google.maps.LatLng(suzuka.lat, suzuka.lng);
        //     break;
        case 6:
          latlng = new google.maps.LatLng(tsu.lat, tsu.lng);
          break;
        // case 7:
        //     latlng = new google.maps.LatLng(ise.lat, ise.lng);
        //     break;
        // case 8:
        //     latlng = new google.maps.LatLng(ogaki.lat, ogaki.lng);
        //     break;
      }
      var myOptions = {
        zoom: 17 /*拡大比率*/,
        center: latlng /*表示枠内の中心点*/,
      };
      switch (i) {
        case 0:
          map = new google.maps.Map(
            document.getElementById("koshigaya_map"),
            myOptions
          );
          break;
        // case 1:
        //     map = new google.maps.Map(document.getElementById('soka_map'), myOptions);
        //     break;
        // case 2:
        //     map = new google.maps.Map(document.getElementById('honkawagoe_map'), myOptions);
        //     break;
        // case 3:
        //     map = new google.maps.Map(document.getElementById('meisei_map'), myOptions);
        //     break;
        // case 4:
        //     map = new google.maps.Map(document.getElementById('arimatsu_map'), myOptions);
        //     break;
        // case 5:
        //     map = new google.maps.Map(document.getElementById('inazawa_map'), myOptions);
        //     break;
        // case 6:
        //     map = new google.maps.Map(document.getElementById('suzuka_map'), myOptions);
        //     break;
        case 6:
          map = new google.maps.Map(
            document.getElementById("tsu_map"),
            myOptions
          );
          break;
        // case 7:
        //     map = new google.maps.Map(document.getElementById('ise_map'), myOptions);
        //     break;
        // case 8:
        //     map = new google.maps.Map(document.getElementById('ogaki_map'), myOptions);
        //     break;
      }
      /*アイコン設定▼*/
      var icon = new google.maps.MarkerImage(
        "assets/img/common/icon-pin.svg",
        new google.maps.Size(32, 48) /*アイコンサイズ設定*/,
        new google.maps.Point(0, 0) /*アイコン位置設定*/
      );
      var markerOptions = {
        position: latlng,
        map: map,
        icon: icon,
      };
      var marker = new google.maps.Marker(markerOptions);
    }
  },
};

$(window).on("load", function () {
  // console.log('map judge')
  if ($(".c-modal__map")[0]) map.init();
});
